/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/sessions/lifetime_stats" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsAppGroupIdChartsSessionsLifetimeStats } from "./constants";
import type { AppGroupSessionLifetimeStatsResults } from "./types";

export const getAppGroupSessionLifetimeStats = reactQueryFetcherAdapter(
  appsAppGroupIdChartsSessionsLifetimeStats,
  (signal: AbortSignal, appGroupId: string): Promise<AppGroupSessionLifetimeStatsResults> => {
    return fetch(`/apps/${appGroupId}/charts/sessions/lifetime_stats`, "GET", {}, { signal });
  }
);
